import type { SearchTourStep } from './searchTourSteps';

export const ENRICHMENT_TOUR_STEPS: SearchTourStep[] = [
  {
    id: 'search-type',
    title: '1) Choose GENES vs VARIANTS',
    body: 'Switch between GENES and VARIANTS. This changes what the analysis interprets.',
    selector: '[data-demo-tour="enrichment-search-type-tabs"]',
    prepare: ['enrichment-close-modal', 'enrichment-back-to-input'],
  },
  {
    id: 'examples',
    title: '2) Show examples',
    body: 'Use “Show Examples” to load a ready-to-run enrichment input list.',
    selector: '[data-demo-tour="enrichment-show-examples"]',
    prepare: ['enrichment-close-modal', 'enrichment-back-to-input', 'enrichment-show-examples'],
    note: 'If you are already seeing an example list, this step may appear redundant.',
  },
  {
    id: 'params-modal',
    title: '3) Enrichment parameters (modal)',
    body: 'Click “Run Enrichment” to open the parameter modal. Here you confirm thresholds and the data source before the computation.',
    selector: '[data-demo-tour="enrichment-modal-root"]',
    fallbackSelector: '[data-demo-tour="enrichment-run-button"]',
    prepare: ['enrichment-back-to-input', 'enrichment-open-modal'],
  },
  {
    id: 'run',
    title: '4) Confirm parameters in modal',
    body: 'Review thresholds and confirm by submitting the modal.',
    selector: '[data-demo-tour="enrichment-modal-submit"]',
    prepare: ['enrichment-open-modal'],
  },
  {
    id: 'results',
    title: '5) Compute enrichment results',
    body: 'Submit the modal. The results will appear right after the computation.',
    selector: '[data-demo-tour="enrichment-results-summary"]',
    fallbackSelector: '[data-demo-tour="enrichment-results-area"]',
    prepare: ['enrichment-submit-modal'],
  },
  {
    id: 'intersection-click',
    title: '6) Click an intersection',
    body: 'Click an “Intersection” value in the results table. It navigates to Search filtered by the intersection members (genes when you run GENES enrichment, variants when you run VARIANTS enrichment).',
    selector: '[data-demo-tour="enrichment-intersection-button"]',
  },
  {
    id: 'disease-click',
    title: '7) Click a disease',
    body: 'Click a “Disease/Phenotype” value. It navigates to Search with that disease selected.',
    selector: '[data-demo-tour="enrichment-disease-button"]',
  },
];
